import { GridColumnDataType } from '@infragistics/igniteui-angular';

export class GridColumnConfig {
    fieldName: string;
    isSortable = true;
    allowFiltering = true;
    header: string;
    dataType: GridColumnDataType = GridColumnDataType.String;
    isCustomTemplate = false;
    isResizable = true;
    canHide = true;
    isHidden = false;
    isPinned = false;
    requiredPermission: string;
    width?: string;
    isTrendingValue = false;
    trendingThreshold?: number;
    index: number;
    formatter: (v: any) => string;

    constructor(init?: Partial<GridColumnConfig>) {
        if (!!init) {
            Object.assign(this, init);
        }
    }
}
